import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import { CreateCustomerTitleBar, WarningCustomerModal } from "../../../../configs/customer";
import CancelModal from "../../../../shared/components/CancelModal";

interface TitleProps {
    setValidated: Function;
    submitForm: Function;
    isLoading?: boolean;

}

const Title = ({
    setValidated,
    submitForm,
    isLoading = false,
}:
  TitleProps
) => {
    const navigate = useNavigate();
    const [showCancelModal, setShowCancelModal] = useState(false);

    const handleCancel = () => {
        setShowCancelModal(true);
    };

    const handleConfirmCancel = () => {
        setShowCancelModal(false);
        navigate("/customers");
    };

    const titleActions: TitleAction[] = [
        {
            title: CreateCustomerTitleBar.cancelButton,
            onClick: handleCancel,
        },
        {
            title: CreateCustomerTitleBar.addButton,
            variant: "contained",
            isLoading,
            onClick: () => {
                if (isLoading) return;
                setValidated(true);
                submitForm();
            },
        },
    ];

    return (
        <>
            <TitleRow title={CreateCustomerTitleBar.title} actions={titleActions} />
            {showCancelModal && (
              <CancelModal
                title={WarningCustomerModal.title}
                contentText={WarningCustomerModal.context}
                open={showCancelModal}
                handleClose={() => setShowCancelModal(false)}
                handleConfirm={handleConfirmCancel}
              />
            )}
        </>
    );
};

export default Title;
